export function localizedServiceName(row, locale) {
  if (!row) return '';
  if (locale === 'ar' && row.name_ar?.trim()) return row.name_ar.trim();
  return (row.name || '').trim();
}

export function localizedServiceDescription(row, locale) {
  if (!row) return '';
  if (locale === 'ar' && row.description_ar?.trim()) return row.description_ar.trim();
  return (row.description || '').trim();
}

export function localizedServiceDuration(row, locale) {
  if (!row) return '';
  if (locale === 'ar' && row.duration_label_ar?.trim()) return row.duration_label_ar.trim();
  return (row.duration_label || '').trim();
}

export function localizeStoredServiceType(type, catalog, locale) {
  const label = (type || '').trim();
  if (!label) return '';
  const match = (catalog || []).find(
    (row) => row.name === label || row.name_ar === label,
  );
  return match ? localizedServiceName(match, locale) : label;
}
